import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./AADevine.css";
import "./Ourademo.css";
import fetchBase from "../utils/fetchBase";
import { Helmet } from "react-helmet-async";

const AADevine = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const [form, setForm] = useState({
            name: "",
            lovedOneName: "",
            phone: "",
            zip: "",
            veteran: "",
    });
    const [submitted, setSubmitted] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const [error, setError] = useState(false);

        const handleSubmit = async (e) => {
            e.preventDefault();
            setError(false);

            try {
                const res = await fetch(`${fetchBase}/api/leads/aa-devine`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ ...form, sourcePage: "hub" }),
                });

                if (!res.ok) {
                    throw new Error("Submission failed");
                }

                setSubmitted(true);
            } catch (err) {
                setError(true);
            }
        };

        return (
            <div className="devine-page">
                <Helmet>
                    <title>Private In-Home Senior Care in Melissa, TX | A&A Devine Home Health</title>
                    <meta name="description" content="A&A Devine Home Health provides compassionate, background-checked in-home senior care in Melissa, Allen, Plano & McKinney, TX. VA benefit authorized. Call (405) 314-6181." />
                    <script type="application/ld+json">
                        {JSON.stringify({
                            "@context": "https://schema.org",
                            "@type": "HomeHealthCareService",
                            "name": "A&A Devine Home Health",
                            "telephone": "+1-405-314-6181",
                            "address": {
                                "@type": "PostalAddress",
                                "streetAddress": "3309 Herron Dr",
                                "addressLocality": "Melissa",
                                "addressRegion": "TX",
                                "postalCode": "75454",
                                "addressCountry": "US"
                            },
                            "areaServed": ["Melissa, TX", "Allen, TX", "Plano, TX", "McKinney, TX"],
                            "url": "https://ouralife.net/partners/aa-devine"
                        })}
                    </script>
                </Helmet>
            {/* Top Bar */}
                <div className="devine-topbar">
                    <Link to="/#partners">
                        <img
                            src="/images/AADevine.png"
                            alt="A&A Devine Home Health"
                            className="devine-topbar-logo"
                        />
                    </Link>
                        <nav className="devine-city-badges">
                            <Link to="/partners/aa-devine/melissa-home-care">
                                <img src="/images/melissa_logo.webp" alt="Melissa, TX" />
                            </Link>
                            <Link to="/partners/aa-devine/allen-home-care">
                                <img src="/images/allen_logo.png" alt="Allen, TX" />
                            </Link>
                            <Link to="/partners/aa-devine/plano-home-care">
                                <img src="/images/p_logo.png" alt="Plano, TX" />
                            </Link>
                            <Link to="/partners/aa-devine/mckinney-home-care">
                                <img src="/images/mckinney_logo.png" alt="McKinney, TX" />
                            </Link>
                        </nav>
                    <a href="tel:4053146181" className="devine-topbar-call">
                    Call Direct: (405) 314-6181 — Available 24/7
                </a>
            </div>

            {/* Hero */}
            <section className="devine-hero">
                <div className="devine-hero-copy">
                    <img
                        src="/images/MomGma.png"
                        alt="Caregiver serving a meal tray to an elderly client at home"
                        className="devine-hero-image"
                    />
                    <h1>Compassionate, Reliable In-Home Senior Care in Melissa, Allen, Plano &amp; McKinney</h1>
                    <p className="devine-subhead">
                        Stop carrying caregiver burnout alone. We match your parent with
                        background-checked caregivers for daily meals, mobility, and
                        companionship — so you can go back to being their son or daughter.
                    </p>
                        <ul className="devine-trust-badges">
                            <li>✓ Fully Licensed &amp; Insured</li>
                            <li>✓ 100% Background-Checked Staff</li>
                            <li>✓ VA Benefit Authorized</li>
                            <li>✓ 24-Hour, Overnight &amp; Live-In Care Available</li>
                            <li>✓ Private Duty Nursing Available</li>
                        </ul>
                </div>

                <div className="devine-form-card">
                    {submitted ? (
                        <div className="devine-form-success">
                            <h3>Thank you.</h3>
                            <p>
                                A care coordinator will reach out shortly. If this is urgent,
                                call us directly at{" "}
                                <a href="tel:4053146181">(405) 314-6181</a>.
                            </p>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit} className="devine-form">
                            <h3>Schedule a Free, No-Obligation In-Home Care Consultation</h3>

                            <label>
                                Requester's Name
                                <input
                                    type="text"
                                    name="name"
                                    value={form.name}
                                    onChange={handleChange}
                                    required
                                />
                            </label>

                            <label>
                                Loved One's Full Name
                                <input
                                    type="text"
                                    name="lovedOneName"
                                    value={form.lovedOneName}
                                    onChange={handleChange}
                                    required
                                />
                            </label>

                            <label>
                                Phone Number
                                <input
                                    type="tel"
                                    name="phone"
                                    value={form.phone}
                                    onChange={handleChange}
                                    required
                                />
                            </label>

                            <label>
                                Parent's Zip Code
                                <input
                                    type="text"
                                    name="zip"
                                    value={form.zip}
                                    onChange={handleChange}
                                    required
                                />
                            </label>

                            <label>
                                Are they a wartime veteran or spouse?
                                <select
                                    name="veteran"
                                    value={form.veteran}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="" disabled>
                                        Select one
                                    </option>
                                    <option value="yes">Yes</option>
                                    <option value="no">No</option>
                                    <option value="not_sure">Not Sure</option>
                                </select>
                            </label>

                                {error && (
                                    <p style={{ color: "#B91C1C", fontSize: "14px", marginBottom: "16px" }}>
                                        Something went wrong. Please try again, or call us directly at (405) 314-6181.
                                    </p>
                                )}

                            <button type="submit" className="devine-cta">
                                GET MY FREE CARE ASSESSMENT
                            </button>
                        </form>
                    )}
                </div>
            </section>

            {/* Empathy Section */}
            <section className="devine-empathy">
                <h2>You Don't Have to Do This All Yourself</h2>
                <p>
                    Balancing your own career, children, and marriage while managing an
                    aging parent's health is overwhelming. Whether Mom needs help getting
                    dressed safely in the morning, or Dad needs companionship and meal
                    prep so he doesn't wander, our team steps in to handle the daily
                    physical work — giving you back peace of mind.
                </p>

                <div className="devine-checklist">
                    <div>
                        <h4>Skilled &amp; Non-Skilled Care</h4>
                        <ul>
                            <li>Bathing, Dressing &amp; Grooming</li>
                            <li>Skilled Nursing &amp; Wound Care</li>
                            <li>Medication Reminders &amp; Administration</li>
                            <li>Mobility Assistance &amp; Fall Prevention</li>
                            <li>Feeding, Toileting &amp; Positioning</li>
                            <li>Light Housekeeping &amp; Transportation</li>
                        </ul>
                    </div>
                    <div>
                        <h4>Pediatric Care</h4>
                        <ul>
                            <li>Private Duty Skilled Nursing</li>
                            <li>Medical Nutrition Therapy</li>
                            <li>Speech-Language Therapy</li>
                            <li>Occupational &amp; Physical Therapy</li>
                            <li>G-Button Care</li>
                        </ul>
                    </div>
                </div>
            </section>

            {/* VA & Funding */}
            <section className="devine-funding">
                <h2>Confused About How to Pay for Care?</h2>
                <p>
                    Quality care doesn't always have to come out of pocket. We help local
                    families navigate private-pay budgets, Long-Term Care Insurance, and{" "}
                    <strong>VA Aid &amp; Attendance benefits</strong>. If your parent or
                    their spouse served during wartime, they may qualify for hours of care
                    at little to no cost. We guide you through the process for free —
                    proudly serving the DFW veteran community.
                </p>
            </section>

                {/* Resources */}
                <section className="devine-resources">
                    <h2>Helpful Resources for Families</h2>
                    <div className="devine-resources-grid">
                        <Link to="/partners/aa-devine/resources/signs-parent-needs-help">5 Signs Your Elderly Parent May Need Help at Home</Link>
                        <Link to="/partners/aa-devine/resources/home-care-vs-home-health-care">Home Care vs. Home Health Care: What Is the Difference?</Link>
                        <Link to="/partners/aa-devine/resources/questions-to-ask-home-care-agency">Questions to Ask a Home Care Agency Before Hiring</Link>
                        <Link to="/partners/aa-devine/resources/how-to-pay-for-in-home-care">How to Pay for In-Home Care: A Guide to Funding Options</Link>
                        <Link to="/partners/aa-devine/resources/hospital-discharge-guide">Bringing a Parent Home Safely: A Hospital Discharge Guide</Link>
                        <Link to="/partners/aa-devine/resources/what-is-concierge-elder-care">What Is Concierge Elder Care? Why RN Oversight Matters</Link>
                        <Link to="/partners/aa-devine/resources/long-distance-caregiving-support">Peace of Mind from Afar: Support for Long-Distance Families</Link>
                        <Link to="/partners/aa-devine/resources/dementia-memory-care-strategies">Staying Safe at Home: Dementia and Memory Care Strategies</Link>
                    </div>
                </section>

                {/* Trust / Reviews */}
                <section className="devine-trust">
                <h2>What Other Local Families Say</h2>
                <div className="devine-review-cards">
                    <div className="devine-review-card">
                        <p>
                            "I was overwhelmed trying to care for my mother after her fall.
                            A&amp;A Devine had a caregiver at her house within days. She
                            feels like family to us now."
                        </p>
                        <span>— Adult Daughter, Melissa TX</span>
                    </div>
                    <div className="devine-review-card">
                        <p>
                            "They helped us understand my father's VA benefits when we
                            thought we'd have to cover everything ourselves. I can't
                            recommend them enough."
                        </p>
                        <span>— Adult Son, Plano TX</span>
                    </div>
                </div>
                <p className="devine-owner-note">
                    Family owned and led by <strong>Esther Tabenyang, RN</strong>, with 15
                    years of nursing experience.
                </p>
            </section>

            {/* Process */}
            <section className="devine-process">
                <h2>What Happens Next</h2>
                <ol>
                    <li>
                        <span className="devine-step-num">1</span>
                        <div>
                            <h4>Quick 10-Minute Phone Call</h4>
                            <p>
                                We discuss your parent's daily routine, medical needs, and
                                location.
                            </p>
                        </div>
                    </li>
                    <li>
                        <span className="devine-step-num">2</span>
                        <div>
                            <h4>In-Home Assessment</h4>
                            <p>
                                We meet you and your parent at home to design a customized
                                care plan and match the right caregiver personality.
                            </p>
                        </div>
                    </li>
                    <li>
                        <span className="devine-step-num">3</span>
                        <div>
                            <h4>Care Begins — Fast</h4>
                            <p>
                                We accept urgent referrals and short-notice shifts around the
                                clock. Your caregiver's visits are logged and verified in
                                real time, so you get dependable updates, not guesswork.
                            </p>
                        </div>
                    </li>
                </ol>
            </section>

            {/* Final CTA */}
                <section className="devine-final-cta">
                    <h2>Give Your Parent the Support They Need &amp; Get Your Peace of Mind Back</h2>
                    <a href="#top" className="devine-cta">
                        SCHEDULE YOUR FREE CARE CONSULTATION
                    </a>
                    <p>
                        Or call us directly right now at{" "}
                        <a href="tel:4053146181">(405) 314-6181</a>
                    </p>
                </section>

                {/* ── FOOTER ── */}
                <footer className="ourademo-footer">
                    <div className="ourademo-footer-social">
                        <span className="ourademo-footer-follow">Follow us</span>
                        <div className="ourademo-footer-icons">
                            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="ourademo-footer-icon">
                                <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20"><path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.4.6A3 3 0 0 0 .5 6.2C0 8.1 0 12 0 12s0 3.9.5 5.8a3 3 0 0 0 2.1 2.1c1.9.6 9.4.6 9.4.6s7.5 0 9.4-.6a3 3 0 0 0 2.1-2.1C24 15.9 24 12 24 12s0-3.9-.5-5.8zM9.8 15.5V8.5l6.3 3.5-6.3 3.5z"/></svg>
                            </a>
                            <a href="https://x.com" target="_blank" rel="noopener noreferrer" aria-label="X" className="ourademo-footer-icon">
                                <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20"><path d="M18.3 1.6h3.4L14.5 10l8.5 11.4h-7L10.8 14l-6 7.4H1.3l7.7-8.8L1 1.6h7.2l4.6 6.1 5.5-6.1zm-1.2 18.7h1.9L6.8 3.5H4.8L17.1 20.3z"/></svg>
                            </a>
                            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="ourademo-footer-icon">
                                <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20"><path d="M24 12.1C24 5.4 18.6 0 12 0S0 5.4 0 12.1c0 6 4.4 11 10.1 11.9v-8.4H7.1v-3.5h3V9.4c0-3 1.8-4.6 4.5-4.6 1.3 0 2.7.2 2.7.2v2.9h-1.5c-1.5 0-1.9.9-1.9 1.9v2.2h3.3l-.5 3.5h-2.8V24C19.6 23.1 24 18.1 24 12.1z"/></svg>
                            </a>
                            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="ourademo-footer-icon">
                                <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20"><path d="M20.4 20.4h-3.6v-5.6c0-1.3 0-3-1.8-3s-2.1 1.4-2.1 2.9v5.7H9.3V9h3.5v1.6h.1c.5-.9 1.6-1.8 3.3-1.8 3.5 0 4.2 2.3 4.2 5.4v6.2zM5.3 7.4a2.1 2.1 0 1 1 0-4.2 2.1 2.1 0 0 1 0 4.2zM3.5 20.4h3.6V9H3.5v11.4zM22.2 0H1.8C.8 0 0 .8 0 1.8v20.4C0 23.2.8 24 1.8 24h20.4c1 0 1.8-.8 1.8-1.8V1.8C24 .8 23.2 0 22.2 0z"/></svg>
                            </a>
                            <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="ourademo-footer-icon">
                                <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20"><path d="M19.6 3.3A4.8 4.8 0 0 1 14.8 0h-3.5v16.4a2.9 2.9 0 0 1-2.9 2.5 2.9 2.9 0 0 1-2.9-2.9 2.9 2.9 0 0 1 2.9-2.9c.3 0 .5 0 .8.1V9.6a6.4 6.4 0 0 0-.8-.1 6.4 6.4 0 0 0-6.4 6.4 6.4 6.4 0 0 0 6.4 6.4 6.4 6.4 0 0 0 6.4-6.4V8.2a8.2 8.2 0 0 0 4.8 1.5V6.3a4.8 4.8 0 0 1-3-3z"/></svg>
                            </a>
                        </div>
                    </div>
                    <div className="ourademo-footer-bottom">
                        <div className="ourademo-footer-inner">
                            <address className="devine-nap" style={{ fontStyle: "normal", marginBottom: "12px" }}>
                                A&amp;A Devine Home Health — 3309 Herron Dr, Melissa, TX 75454 —{" "}
                                <a href="tel:4053146181">(405) 314-6181</a>
                            </address>
                            <span className="ourademo-footer-brand">© 2026 Oura Business Solutions</span>
                            <nav className="ourademo-footer-links">
                                <Link to="/">Home</Link>
                                <Link to="/apply">Apply</Link>
                                <Link to="/admin/login">Admin Login</Link>
                                <a href="mailto:info@ouralife.net">Support</a>
                            </nav>
                            <p className="ourademo-footer-legal">
                                This provider's care coordination platform is proudly powered by Oura Business Solutions.
                                All rights reserved.
                            </p>
                        </div>
                    </div>
                </footer>
            </div>



                );
            };

export default AADevine;